import React, { useState } from 'react';
import { Text, ScrollView, View, TouchableOpacity, ActivityIndicator } from 'react-native';
import BaseWeb from '../../components/baseWeb';
import styles from '../../styles/etapasAnaliseWebStyles';
import { useNavigation } from '@react-navigation/native';
import { BackArrowIcon, StepArrowIcon, CheckIcon } from '../../components/iconsWeb';

const getStepColor = (currentStatus, stepStatus) => {
    if (currentStatus > stepStatus) return '#077755';
    if (currentStatus === stepStatus) return '#730d83';
    return '#D3D3D3';
};

export default function EtapasCorretagemWeb({ route }) {
    const navigation = useNavigation();

    const [usuario_id, setUsuario_id] = useState('');
    const [email_solicitante, setEmail_solicitante] = useState('');
    const {
        status = 1,
        endereco_imovel,
        valor_de_venda,
        percentual_corretagem,
        payload_prop,
        payload_corretores,
        payload_testemunhas
    } = route.params || {};

    const [loading, setLoading] = useState(false);

    const steps = [
        { label: 'Dados do imóvel', status: 1, view: 'DadosDoImovelContratoCorretagemWeb' },
        { label: 'Dados do(s) contratante(s)', status: 2, view: 'DadosContratanteWeb' },
        { label: 'Dados do(s) contratado(s)', status: 3, view: 'DadosContradadoCorretorWeb' },
        { label: 'Dados das testemunhas', status: 4, view: 'DadosTestemunhasCorretagemWeb' },
    ];

    const handleStepNavigation = (step) => {
        if (status === step.status) {
            navigation.navigate(step.view, {
                etapa: step.label,
                status: step.status,
                usuario_id,
                email_solicitante,
                endereco_imovel,
                valor_de_venda,
                percentual_corretagem,
                payload_prop,
                payload_corretores,
                payload_testemunhas
            });
        }
    };

    return (
        <BaseWeb>
            {(userInfo) => {
                setUsuario_id(userInfo.id)
                setEmail_solicitante(userInfo.email)
                return (
                    <ScrollView contentContainerStyle={styles.contentMinimal}>
                        <View style={styles.headerContainer}>
                            <Text style={styles.headerTitle}>Gerador de contratos</Text>
                        </View>

                        <Text style={styles.classificacaoText}>Contrato de corretagem</Text>

                        <View style={styles.stepsContainer}>
                            {steps.map((step, index) => (
                                <TouchableOpacity
                                    key={step.status}
                                    style={[
                                        styles.stepWrapper,
                                        status < step.status && styles.stepWrapperDisabled
                                    ]}
                                    disabled={status < step.status}
                                    onPress={() => handleStepNavigation(step)}
                                >
                                    <View style={styles.stepLeft}>
                                        {index !== steps.length - 1 && <View style={styles.stepLine} />}
                                        <View style={[styles.stepCircle, { backgroundColor: getStepColor(status, step.status) }]} />
                                        <Text style={styles.stepText}>{step.label}</Text>
                                    </View>
                                    <View>
                                        {status === step.status ? <StepArrowIcon /> : status > step.status ? <CheckIcon /> : null}
                                    </View>
                                </TouchableOpacity>
                            ))}
                        </View>
                    </ScrollView>
                );
            }}
        </BaseWeb>
    );
}
